import { BettingInformation } from '../Model/BettingInformation'
import { ICheckBoxValidatorProcessor } from './ICheckBoxValidatorProcessor'

export abstract class ForwardingCheckBoxValidatorProcessor implements ICheckBoxValidatorProcessor {
  constructor(protected next: ICheckBoxValidatorProcessor) {}
  abstract validate(count: number, bettingContext: BettingInformation): boolean
}
